import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { openIntercom } from '@/providers/intercom';
import { User } from '@/types/auth.types';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { FlexCol } from '@/UI/styles';

const ENTERPRISE_FEATURE_KEYS = [
  I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_CUSTOM_CREDITS,
  I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_TEAM_TRAINING,
  I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_PREMIUM_SUPPORT,
  I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_OWN_API_KEYS,
  I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_API_WORKFLOWS,
];

function EnterprisePackage({ currentUser }: { currentUser: User | undefined }) {
  const { t } = useTranslation();
  const handleIntercomClick = () => {
    if (!currentUser) {
      const mailtoLink = document.createElement('a');
      mailtoLink.href = 'mailto:hello@weavy.ai';
      mailtoLink.target = '_blank';
      mailtoLink.click();
      return;
    }
    openIntercom();
  };
  return (
    <Box
      sx={{
        width: '100%',
        // height: '284px',
        backgroundColor: color.Black92,
        borderRadius: 2,
        p: 6,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: { xs: '100%', md: '260px' },
          ml: 'auto',
        }}
      >
        <Typography variant="h2" sx={{ mb: 4 }}>
          {t(I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.TITLE)}
        </Typography>
        <ButtonContained onClick={handleIntercomClick}>{t(I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.CTA)}</ButtonContained>
      </Box>
      <FlexCol
        sx={{
          width: { xs: '100%', md: '380px' },
          mr: 'auto',
          mt: { xs: 4, md: 0 },
          ml: { xs: 0, md: 9 },
        }}
      >
        <Typography variant="body-sm-rg" color={color.White80_T} sx={{ mb: 4 }}>
          {t(I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.SUBTITLE)}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {ENTERPRISE_FEATURE_KEYS.map((featureKey, index) => (
            <Box key={index} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
              <i className="fa-light fa-check" style={{ fontSize: '0.75rem' }}></i>
              <Typography variant="body-sm-rg" color={color.White80_T}>
                {t(featureKey)}
              </Typography>
            </Box>
          ))}
        </Box>
      </FlexCol>
    </Box>
  );
}

export default EnterprisePackage;
